import React, { FC } from 'react';
import { Container, Row } from 'react-bootstrap';
import PageTitle from '../../components/layout/pageTitle/PageTitle';

const PageNotFound: FC = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageTitle title="404 page not found"></PageTitle>
          <Row></Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PageNotFound;
